/*=========================================================================================
  File Name: apiState.js
  Description: Api Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import store from '../store'

const userDefaults = {
  id          : 0,          // From Auth
  name        : 'Turkish Restaurant', // From Auth
  last_name   : '',
  full_name   : '',
  photoURL    : require('@/assets/images/portrait/small/profile_icon.png'),
  photo       : require('@/assets/images/portrait/small/profile_icon.png'), // From Auth
  email       : 'info@turkishrestaurant.com',
  user_group  : 4,
  user_property: {}
}

export default {
  reservationStore: null,
  reservationData: null,
  reservationToken: null,
  currentUser: userDefaults,
  profile: {},
  saved_user_id: null,
  post_commit_status: '',
  properties: [],
  property_types: [],
  restaurantlist: [],
  userlists: [],
  selectedRestaurant: null,
  pickupHours: [],
  deliveryHours: [],
  orders: [],
  cateringOrders: [],
  cateringOrderOffers: [],
  contents: [],
  propertylist: [],
  sectionlist: [],
  token_valid: false,
  order_by_date: true,
  sizelist: [],
  sizeOptions: [],
  orderStatuses: [],
  orderStatusChanged: false,
  pass: false,
  boundaries: [],
  coupons: [],
  productlist: [],
  modifierlist: [],
  modifieritems: [],
  isUserLoggedIn: async () => {
    let isAuthenticated = false
    await store.dispatch('api/checkTokenValid').then((response) => {
      if (response.data.status === true) {
        if (response.data.user.user_group === 2) {
          store.commit('api/SET_SELECTED_RESTAURANT', response.data.user)
        }
        isAuthenticated = true
      } else {
        isAuthenticated = false
      }
    }).catch(() => {
      isAuthenticated = false
    })
    return isAuthenticated
  }
}
